/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnableOrderdayThu } from './EnableOrderdayThu';
import {
    EnableOrderdayThuFromJSON,
    EnableOrderdayThuFromJSONTyped,
    EnableOrderdayThuToJSON,
    EnableOrderdayThuToJSONTyped,
} from './EnableOrderdayThu';
import type { ShipPreviousStockFlg } from './ShipPreviousStockFlg';
import {
    ShipPreviousStockFlgFromJSON,
    ShipPreviousStockFlgFromJSONTyped,
    ShipPreviousStockFlgToJSON,
    ShipPreviousStockFlgToJSONTyped,
} from './ShipPreviousStockFlg';
import type { EnableOrderdayTue } from './EnableOrderdayTue';
import {
    EnableOrderdayTueFromJSON,
    EnableOrderdayTueFromJSONTyped,
    EnableOrderdayTueToJSON,
    EnableOrderdayTueToJSONTyped,
} from './EnableOrderdayTue';
import type { EnableShipdayWed } from './EnableShipdayWed';
import {
    EnableShipdayWedFromJSON,
    EnableShipdayWedFromJSONTyped,
    EnableShipdayWedToJSON,
    EnableShipdayWedToJSONTyped,
} from './EnableShipdayWed';
import type { DeleteFlg } from './DeleteFlg';
import {
    DeleteFlgFromJSON,
    DeleteFlgFromJSONTyped,
    DeleteFlgToJSON,
    DeleteFlgToJSONTyped,
} from './DeleteFlg';
import type { EnableArrivalFri } from './EnableArrivalFri';
import {
    EnableArrivalFriFromJSON,
    EnableArrivalFriFromJSONTyped,
    EnableArrivalFriToJSON,
    EnableArrivalFriToJSONTyped,
} from './EnableArrivalFri';
import type { EnableOrderdayMon } from './EnableOrderdayMon';
import {
    EnableOrderdayMonFromJSON,
    EnableOrderdayMonFromJSONTyped,
    EnableOrderdayMonToJSON,
    EnableOrderdayMonToJSONTyped,
} from './EnableOrderdayMon';
import type { EnableOrderdaySun } from './EnableOrderdaySun';
import {
    EnableOrderdaySunFromJSON,
    EnableOrderdaySunFromJSONTyped,
    EnableOrderdaySunToJSON,
    EnableOrderdaySunToJSONTyped,
} from './EnableOrderdaySun';
import type { EnableArrivalWed } from './EnableArrivalWed';
import {
    EnableArrivalWedFromJSON,
    EnableArrivalWedFromJSONTyped,
    EnableArrivalWedToJSON,
    EnableArrivalWedToJSONTyped,
} from './EnableArrivalWed';
import type { EnableShipdayMon } from './EnableShipdayMon';
import {
    EnableShipdayMonFromJSON,
    EnableShipdayMonFromJSONTyped,
    EnableShipdayMonToJSON,
    EnableShipdayMonToJSONTyped,
} from './EnableShipdayMon';
import type { EnableShipdaySun } from './EnableShipdaySun';
import {
    EnableShipdaySunFromJSON,
    EnableShipdaySunFromJSONTyped,
    EnableShipdaySunToJSON,
    EnableShipdaySunToJSONTyped,
} from './EnableShipdaySun';
import type { EnableShipdayThu } from './EnableShipdayThu';
import {
    EnableShipdayThuFromJSON,
    EnableShipdayThuFromJSONTyped,
    EnableShipdayThuToJSON,
    EnableShipdayThuToJSONTyped,
} from './EnableShipdayThu';
import type { EnableShipdayTue } from './EnableShipdayTue';
import {
    EnableShipdayTueFromJSON,
    EnableShipdayTueFromJSONTyped,
    EnableShipdayTueToJSON,
    EnableShipdayTueToJSONTyped,
} from './EnableShipdayTue';
import type { CalcStockShippingorderFlg } from './CalcStockShippingorderFlg';
import {
    CalcStockShippingorderFlgFromJSON,
    CalcStockShippingorderFlgFromJSONTyped,
    CalcStockShippingorderFlgToJSON,
    CalcStockShippingorderFlgToJSONTyped,
} from './CalcStockShippingorderFlg';
import type { EnableArrivalSat } from './EnableArrivalSat';
import {
    EnableArrivalSatFromJSON,
    EnableArrivalSatFromJSONTyped,
    EnableArrivalSatToJSON,
    EnableArrivalSatToJSONTyped,
} from './EnableArrivalSat';
import type { EnableArrivalTue } from './EnableArrivalTue';
import {
    EnableArrivalTueFromJSON,
    EnableArrivalTueFromJSONTyped,
    EnableArrivalTueToJSON,
    EnableArrivalTueToJSONTyped,
} from './EnableArrivalTue';
import type { EnableArrivalThu } from './EnableArrivalThu';
import {
    EnableArrivalThuFromJSON,
    EnableArrivalThuFromJSONTyped,
    EnableArrivalThuToJSON,
    EnableArrivalThuToJSONTyped,
} from './EnableArrivalThu';
import type { EnableOrderdaySat } from './EnableOrderdaySat';
import {
    EnableOrderdaySatFromJSON,
    EnableOrderdaySatFromJSONTyped,
    EnableOrderdaySatToJSON,
    EnableOrderdaySatToJSONTyped,
} from './EnableOrderdaySat';
import type { EnableOrderdayWed } from './EnableOrderdayWed';
import {
    EnableOrderdayWedFromJSON,
    EnableOrderdayWedFromJSONTyped,
    EnableOrderdayWedToJSON,
    EnableOrderdayWedToJSONTyped,
} from './EnableOrderdayWed';
import type { EnableShipdaySat } from './EnableShipdaySat';
import {
    EnableShipdaySatFromJSON,
    EnableShipdaySatFromJSONTyped,
    EnableShipdaySatToJSON,
    EnableShipdaySatToJSONTyped,
} from './EnableShipdaySat';
import type { InternalTransferHubFlg } from './InternalTransferHubFlg';
import {
    InternalTransferHubFlgFromJSON,
    InternalTransferHubFlgFromJSONTyped,
    InternalTransferHubFlgToJSON,
    InternalTransferHubFlgToJSONTyped,
} from './InternalTransferHubFlg';
import type { EnableArrivalMon } from './EnableArrivalMon';
import {
    EnableArrivalMonFromJSON,
    EnableArrivalMonFromJSONTyped,
    EnableArrivalMonToJSON,
    EnableArrivalMonToJSONTyped,
} from './EnableArrivalMon';
import type { EnableArrivalSun } from './EnableArrivalSun';
import {
    EnableArrivalSunFromJSON,
    EnableArrivalSunFromJSONTyped,
    EnableArrivalSunToJSON,
    EnableArrivalSunToJSONTyped,
} from './EnableArrivalSun';
import type { InternalInboundFlg } from './InternalInboundFlg';
import {
    InternalInboundFlgFromJSON,
    InternalInboundFlgFromJSONTyped,
    InternalInboundFlgToJSON,
    InternalInboundFlgToJSONTyped,
} from './InternalInboundFlg';
import type { TodayShipRecDelayFlg } from './TodayShipRecDelayFlg';
import {
    TodayShipRecDelayFlgFromJSON,
    TodayShipRecDelayFlgFromJSONTyped,
    TodayShipRecDelayFlgToJSON,
    TodayShipRecDelayFlgToJSONTyped,
} from './TodayShipRecDelayFlg';
import type { EnableShipdayFri } from './EnableShipdayFri';
import {
    EnableShipdayFriFromJSON,
    EnableShipdayFriFromJSONTyped,
    EnableShipdayFriToJSON,
    EnableShipdayFriToJSONTyped,
} from './EnableShipdayFri';
import type { EnableOrderdayFri } from './EnableOrderdayFri';
import {
    EnableOrderdayFriFromJSON,
    EnableOrderdayFriFromJSONTyped,
    EnableOrderdayFriToJSON,
    EnableOrderdayFriToJSONTyped,
} from './EnableOrderdayFri';

/**
 * センターマスタ登録用
 * @export
 * @interface CenterUpdateIF
 */
export interface CenterUpdateIF {
    /**
     * 
     * @type {number}
     * @memberof CenterUpdateIF
     */
    centerId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CenterUpdateIF
     */
    companyId?: number | null;
    /**
     * 自社センターID
     * @type {string}
     * @memberof CenterUpdateIF
     */
    orgCenterId: string;
    /**
     * センター名
     * @type {string}
     * @memberof CenterUpdateIF
     */
    centerName: string;
    /**
     * 
     * @type {string}
     * @memberof CenterUpdateIF
     */
    centerAddress?: string | null;
    /**
     * 
     * @type {EnableShipdayMon}
     * @memberof CenterUpdateIF
     */
    enableShipdayMon?: EnableShipdayMon | null;
    /**
     * 
     * @type {EnableShipdayTue}
     * @memberof CenterUpdateIF
     */
    enableShipdayTue?: EnableShipdayTue | null;
    /**
     * 
     * @type {EnableShipdayWed}
     * @memberof CenterUpdateIF
     */
    enableShipdayWed?: EnableShipdayWed | null;
    /**
     * 
     * @type {EnableShipdayThu}
     * @memberof CenterUpdateIF
     */
    enableShipdayThu?: EnableShipdayThu | null;
    /**
     * 
     * @type {EnableShipdayFri}
     * @memberof CenterUpdateIF
     */
    enableShipdayFri?: EnableShipdayFri | null;
    /**
     * 
     * @type {EnableShipdaySat}
     * @memberof CenterUpdateIF
     */
    enableShipdaySat?: EnableShipdaySat | null;
    /**
     * 
     * @type {EnableShipdaySun}
     * @memberof CenterUpdateIF
     */
    enableShipdaySun?: EnableShipdaySun | null;
    /**
     * 
     * @type {EnableArrivalMon}
     * @memberof CenterUpdateIF
     */
    enableArrivalMon?: EnableArrivalMon | null;
    /**
     * 
     * @type {EnableArrivalTue}
     * @memberof CenterUpdateIF
     */
    enableArrivalTue?: EnableArrivalTue | null;
    /**
     * 
     * @type {EnableArrivalWed}
     * @memberof CenterUpdateIF
     */
    enableArrivalWed?: EnableArrivalWed | null;
    /**
     * 
     * @type {EnableArrivalThu}
     * @memberof CenterUpdateIF
     */
    enableArrivalThu?: EnableArrivalThu | null;
    /**
     * 
     * @type {EnableArrivalFri}
     * @memberof CenterUpdateIF
     */
    enableArrivalFri?: EnableArrivalFri | null;
    /**
     * 
     * @type {EnableArrivalSat}
     * @memberof CenterUpdateIF
     */
    enableArrivalSat?: EnableArrivalSat | null;
    /**
     * 
     * @type {EnableArrivalSun}
     * @memberof CenterUpdateIF
     */
    enableArrivalSun?: EnableArrivalSun | null;
    /**
     * 
     * @type {string}
     * @memberof CenterUpdateIF
     */
    centerGroupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CenterUpdateIF
     */
    centerGln?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CenterUpdateIF
     */
    remarks?: string | null;
    /**
     * 
     * @type {DeleteFlg}
     * @memberof CenterUpdateIF
     */
    deleteFlg?: DeleteFlg | null;
    /**
     * 
     * @type {EnableOrderdayMon}
     * @memberof CenterUpdateIF
     */
    enableOrderdayMon?: EnableOrderdayMon | null;
    /**
     * 
     * @type {EnableOrderdayTue}
     * @memberof CenterUpdateIF
     */
    enableOrderdayTue?: EnableOrderdayTue | null;
    /**
     * 
     * @type {EnableOrderdayWed}
     * @memberof CenterUpdateIF
     */
    enableOrderdayWed?: EnableOrderdayWed | null;
    /**
     * 
     * @type {EnableOrderdayThu}
     * @memberof CenterUpdateIF
     */
    enableOrderdayThu?: EnableOrderdayThu | null;
    /**
     * 
     * @type {EnableOrderdayFri}
     * @memberof CenterUpdateIF
     */
    enableOrderdayFri?: EnableOrderdayFri | null;
    /**
     * 
     * @type {EnableOrderdaySat}
     * @memberof CenterUpdateIF
     */
    enableOrderdaySat?: EnableOrderdaySat | null;
    /**
     * 
     * @type {EnableOrderdaySun}
     * @memberof CenterUpdateIF
     */
    enableOrderdaySun?: EnableOrderdaySun | null;
    /**
     * 
     * @type {ShipPreviousStockFlg}
     * @memberof CenterUpdateIF
     */
    shipPreviousStockFlg?: ShipPreviousStockFlg | null;
    /**
     * 
     * @type {TodayShipRecDelayFlg}
     * @memberof CenterUpdateIF
     */
    todayShipRecDelayFlg?: TodayShipRecDelayFlg | null;
    /**
     * 
     * @type {CalcStockShippingorderFlg}
     * @memberof CenterUpdateIF
     */
    calcStockShippingorderFlg?: CalcStockShippingorderFlg | null;
    /**
     * 
     * @type {InternalTransferHubFlg}
     * @memberof CenterUpdateIF
     */
    internalTransferHubFlg?: InternalTransferHubFlg | null;
    /**
     * 
     * @type {InternalInboundFlg}
     * @memberof CenterUpdateIF
     */
    internalInboundFlg?: InternalInboundFlg | null;
    /**
     * 
     * @type {Date}
     * @memberof CenterUpdateIF
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CenterUpdateIF
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CenterUpdateIF
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CenterUpdateIF
     */
    updateUser?: string | null;
}

/**
 * Check if a given object implements the CenterUpdateIF interface.
 */
export function instanceOfCenterUpdateIF(value: object): value is CenterUpdateIF {
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('centerName' in value) || value['centerName'] === undefined) return false;
    return true;
}

export function CenterUpdateIFFromJSON(json: any): CenterUpdateIF {
    return CenterUpdateIFFromJSONTyped(json, false);
}

export function CenterUpdateIFFromJSONTyped(json: any, ignoreDiscriminator: boolean): CenterUpdateIF {
    if (json == null) {
        return json;
    }
    return {
        
        'centerId': json['center_id'] == null ? undefined : json['center_id'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'orgCenterId': json['org_center_id'],
        'centerName': json['center_name'],
        'centerAddress': json['center_address'] == null ? undefined : json['center_address'],
        'enableShipdayMon': json['enable_shipday_mon'] == null ? undefined : EnableShipdayMonFromJSON(json['enable_shipday_mon']),
        'enableShipdayTue': json['enable_shipday_tue'] == null ? undefined : EnableShipdayTueFromJSON(json['enable_shipday_tue']),
        'enableShipdayWed': json['enable_shipday_wed'] == null ? undefined : EnableShipdayWedFromJSON(json['enable_shipday_wed']),
        'enableShipdayThu': json['enable_shipday_thu'] == null ? undefined : EnableShipdayThuFromJSON(json['enable_shipday_thu']),
        'enableShipdayFri': json['enable_shipday_fri'] == null ? undefined : EnableShipdayFriFromJSON(json['enable_shipday_fri']),
        'enableShipdaySat': json['enable_shipday_sat'] == null ? undefined : EnableShipdaySatFromJSON(json['enable_shipday_sat']),
        'enableShipdaySun': json['enable_shipday_sun'] == null ? undefined : EnableShipdaySunFromJSON(json['enable_shipday_sun']),
        'enableArrivalMon': json['enable_arrival_mon'] == null ? undefined : EnableArrivalMonFromJSON(json['enable_arrival_mon']),
        'enableArrivalTue': json['enable_arrival_tue'] == null ? undefined : EnableArrivalTueFromJSON(json['enable_arrival_tue']),
        'enableArrivalWed': json['enable_arrival_wed'] == null ? undefined : EnableArrivalWedFromJSON(json['enable_arrival_wed']),
        'enableArrivalThu': json['enable_arrival_thu'] == null ? undefined : EnableArrivalThuFromJSON(json['enable_arrival_thu']),
        'enableArrivalFri': json['enable_arrival_fri'] == null ? undefined : EnableArrivalFriFromJSON(json['enable_arrival_fri']),
        'enableArrivalSat': json['enable_arrival_sat'] == null ? undefined : EnableArrivalSatFromJSON(json['enable_arrival_sat']),
        'enableArrivalSun': json['enable_arrival_sun'] == null ? undefined : EnableArrivalSunFromJSON(json['enable_arrival_sun']),
        'centerGroupName': json['center_group_name'] == null ? undefined : json['center_group_name'],
        'centerGln': json['center_gln'] == null ? undefined : json['center_gln'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'deleteFlg': json['delete_flg'] == null ? undefined : DeleteFlgFromJSON(json['delete_flg']),
        'enableOrderdayMon': json['enable_orderday_mon'] == null ? undefined : EnableOrderdayMonFromJSON(json['enable_orderday_mon']),
        'enableOrderdayTue': json['enable_orderday_tue'] == null ? undefined : EnableOrderdayTueFromJSON(json['enable_orderday_tue']),
        'enableOrderdayWed': json['enable_orderday_wed'] == null ? undefined : EnableOrderdayWedFromJSON(json['enable_orderday_wed']),
        'enableOrderdayThu': json['enable_orderday_thu'] == null ? undefined : EnableOrderdayThuFromJSON(json['enable_orderday_thu']),
        'enableOrderdayFri': json['enable_orderday_fri'] == null ? undefined : EnableOrderdayFriFromJSON(json['enable_orderday_fri']),
        'enableOrderdaySat': json['enable_orderday_sat'] == null ? undefined : EnableOrderdaySatFromJSON(json['enable_orderday_sat']),
        'enableOrderdaySun': json['enable_orderday_sun'] == null ? undefined : EnableOrderdaySunFromJSON(json['enable_orderday_sun']),
        'shipPreviousStockFlg': json['ship_previous_stock_flg'] == null ? undefined : ShipPreviousStockFlgFromJSON(json['ship_previous_stock_flg']),
        'todayShipRecDelayFlg': json['today_ship_rec_delay_flg'] == null ? undefined : TodayShipRecDelayFlgFromJSON(json['today_ship_rec_delay_flg']),
        'calcStockShippingorderFlg': json['calc_stock_shippingorder_flg'] == null ? undefined : CalcStockShippingorderFlgFromJSON(json['calc_stock_shippingorder_flg']),
        'internalTransferHubFlg': json['internal_transfer_hub_flg'] == null ? undefined : InternalTransferHubFlgFromJSON(json['internal_transfer_hub_flg']),
        'internalInboundFlg': json['internal_inbound_flg'] == null ? undefined : InternalInboundFlgFromJSON(json['internal_inbound_flg']),
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
    };
}

export function CenterUpdateIFToJSON(json: any): CenterUpdateIF {
    return CenterUpdateIFToJSONTyped(json, false);
}

export function CenterUpdateIFToJSONTyped(value?: CenterUpdateIF | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'center_id': value['centerId'],
        'company_id': value['companyId'],
        'org_center_id': value['orgCenterId'],
        'center_name': value['centerName'],
        'center_address': value['centerAddress'],
        'enable_shipday_mon': EnableShipdayMonToJSON(value['enableShipdayMon']),
        'enable_shipday_tue': EnableShipdayTueToJSON(value['enableShipdayTue']),
        'enable_shipday_wed': EnableShipdayWedToJSON(value['enableShipdayWed']),
        'enable_shipday_thu': EnableShipdayThuToJSON(value['enableShipdayThu']),
        'enable_shipday_fri': EnableShipdayFriToJSON(value['enableShipdayFri']),
        'enable_shipday_sat': EnableShipdaySatToJSON(value['enableShipdaySat']),
        'enable_shipday_sun': EnableShipdaySunToJSON(value['enableShipdaySun']),
        'enable_arrival_mon': EnableArrivalMonToJSON(value['enableArrivalMon']),
        'enable_arrival_tue': EnableArrivalTueToJSON(value['enableArrivalTue']),
        'enable_arrival_wed': EnableArrivalWedToJSON(value['enableArrivalWed']),
        'enable_arrival_thu': EnableArrivalThuToJSON(value['enableArrivalThu']),
        'enable_arrival_fri': EnableArrivalFriToJSON(value['enableArrivalFri']),
        'enable_arrival_sat': EnableArrivalSatToJSON(value['enableArrivalSat']),
        'enable_arrival_sun': EnableArrivalSunToJSON(value['enableArrivalSun']),
        'center_group_name': value['centerGroupName'],
        'center_gln': value['centerGln'],
        'remarks': value['remarks'],
        'delete_flg': DeleteFlgToJSON(value['deleteFlg']),
        'enable_orderday_mon': EnableOrderdayMonToJSON(value['enableOrderdayMon']),
        'enable_orderday_tue': EnableOrderdayTueToJSON(value['enableOrderdayTue']),
        'enable_orderday_wed': EnableOrderdayWedToJSON(value['enableOrderdayWed']),
        'enable_orderday_thu': EnableOrderdayThuToJSON(value['enableOrderdayThu']),
        'enable_orderday_fri': EnableOrderdayFriToJSON(value['enableOrderdayFri']),
        'enable_orderday_sat': EnableOrderdaySatToJSON(value['enableOrderdaySat']),
        'enable_orderday_sun': EnableOrderdaySunToJSON(value['enableOrderdaySun']),
        'ship_previous_stock_flg': ShipPreviousStockFlgToJSON(value['shipPreviousStockFlg']),
        'today_ship_rec_delay_flg': TodayShipRecDelayFlgToJSON(value['todayShipRecDelayFlg']),
        'calc_stock_shippingorder_flg': CalcStockShippingorderFlgToJSON(value['calcStockShippingorderFlg']),
        'internal_transfer_hub_flg': InternalTransferHubFlgToJSON(value['internalTransferHubFlg']),
        'internal_inbound_flg': InternalInboundFlgToJSON(value['internalInboundFlg']),
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
    };
}

